<template>
  <div class="devOps_dealtWorkOrder" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
        <el-input :style="iptStyle" placeholder="请输入"  @keyup.enter.native="formSearch('reset')" v-model="form.title" />
      </el-form-item>
      <el-form-item label="系统" prop="models_code" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.models_code" collapse-tags filterable
                   placeholder="请选择系统" clearable>
          <el-option v-for="(key, value) in workOrderSystem" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提出人" prop="demanderId" :label-width="formLabelWidth">
        <el-select size="mini" autocomplete="off" :disabled="isProjectDisabled" v-model="form.submitter_id"  clearable collapse-tags
                   filterable placeholder="请选择提出人">
          <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提出部门" prop="demanderId" :label-width="formLabelWidth">
        <el-cascader :options="options" :show-all-levels="false" clearable filterable @change="handledepartment"></el-cascader>
      </el-form-item>
      <el-form-item label="提交日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_plt_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="起始日期"
            end-placeholder="截止日期" />
      </el-form-item>
      <div>
        <el-form-item>
          <el-button v-if="allMenuList.btn_dealt_work_order_query" style="margin-left:32px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_dealt_work_order_clear" style="font-weight: bold;font-size: 12px;" type="primary"
                     @click="changeReset()">置空
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 58vh;position: relative;">
      <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column  fixed="left"  prop="title" align="center" min-width="120" label="标题" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_text_click_new" @click="showDialogVisible('createWorkOrder', scope.row)">【{{scope.row.id}}】{{scope.row.title}}</span>
        </template>
        </el-table-column>
        <el-table-column prop="type" align="center" width="80" label="类型" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column  prop="module_code" label="系统" width="80" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="state" align="center" width="80" label="状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="remind_count" align="center" width="80" label="催单次数" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="table_text_click_new" style="text-decoration:none;"  @click="showDialogVisible('reminderDetail', scope.row)">{{scope.row.remind_count}}次</span>
          </template>
        </el-table-column>
        <el-table-column prop="submitter_id" label="提出人" width="120" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.submitter_id ? scope.row.submitter_id.nameZh : ''}} {{scope.row.submitter_id.nameEn ? '(' +scope.row.submitter_id.nameEn + ')' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dept" label="提出部门" width="120" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="create_time" align="center"  sortable="custom" width="180" label="提出时间" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button   @click="showDialogVisible('claim', scope.row)" type="text" size="small">认领
            </el-button>
            <el-button  @click="showDialogVisible('transfer', scope.row)" type="text" size="small">转交
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- #region 分页部分 -->
      <div class="block devOpsSpace_page">
        <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                       layout="total, prev, pager, next, sizes" :total="count">
        </el-pagination>
      </div>
      <!-- #endregion -->
    </div>
    <!-- #endregion 表格部分 -->
    <ClaimOrder v-if="dialogVisible.claim" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.claim'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></ClaimOrder>
    <TransferOrder v-if="dialogVisible.transfer" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.transfer'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></TransferOrder>
    <!-- #region dialog 部分 -->
    <CreateWorkOrder  v-if="dialogVisible.createWorkOrder" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.createWorkOrder'
                      :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></CreateWorkOrder>
    <ReminderDetail v-if="dialogVisible.reminderDetail" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.reminderDetail'
                    :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></ReminderDetail>
    <!-- #endregion dialog 部分 -->
  </div>
</template>
<script>
import ClaimOrder from "@/views/tops/devOps/workOrder/components/claimWorkOrder.vue";
import TransferOrder from "@/views/tops/devOps/workOrder/components/transferWorkOrder.vue";
import CreateWorkOrder from "@/views/tops/devOps/workOrder/components/createWorkOrder.vue";
import {getDevOpsSpaceDealWorkOrderApi, getDevOpsSpaceDeptApi} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import { mapState, mapMutations } from 'vuex';
import {getDevOpsSpaceWorkOrderConfigApi} from "@/server/tops/base";
import ReminderDetail from "@/views/tops/devOps/workOrder/components/reminderDetail.vue";
export default {
  components: {ReminderDetail, ClaimOrder,TransferOrder, CreateWorkOrder },
  props: {
  },
  data() {
    return {
      options:[],
      // 表单搜索条件
      form: {
        serach_plt_time:'',
        dept_unicode: '',
        submitter_id: '',
        models_code: '',
        title: '',
      },
      // 列表
      tableData: [],
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        claim: false,
        transfer: false,
        createWorkOrder: false,
        reminderDetail: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      workOrderLevel:[],
      workOrderSystem:[],
    };
  },
  async created() {
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.users = this.allSelect.TEXTUSERSEN;
    await this.$store.dispatch('getDevopsWorkOrderConfig')
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { wid  = '' } = this.$route.query;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : []};

    if(this.$store.state.devOps.userInfo.userId){
      let defauleOwnerId = this.$store.state.devOps.userInfo.userId;
      this.form.ownerId = [defauleOwnerId.toString()];
    }
    if (wid) {
      this.form.submitter_id = '';
      this.form.title = wid;
    }

    this.$nextTick(async () => {
      await this.getDeptMsg();
      await this.formSearch();
      await this.getWorkOrderConfig();
    })
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    //获取部门信息
    getDeptMsg(){
      getDevOpsSpaceDeptApi().then((res)=>{
        if(res.status === 'success'){
         this.options = res.data;
        }
      })
    },
    async getWorkOrderConfig() {
      await getDevOpsSpaceWorkOrderConfigApi({type: 'all'}).then((res) => {
        let level = [];
        let system = [];
        res.data.forEach((item, index) => {
          if (item.type === 2) {
            level.push({key: item.value, value: item.key});
          }else if(item.type === 4){
            system[item.key]= item.value;
          }
        });
        this.workOrderLevel = level;
        this.workOrderSystem = system;
      })
    },
    handledepartment(val){
      if(val[val.length - 1]){
        this.form.dept_unicode = val[val.length - 1];
      }else{
        this.form.dept_unicode = '';
      }
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表单搜索
    async formSearch(type,key) {
      this.form.start_time='';
      this.form.end_time='';
      if(this.form.serach_plt_time){
        if(this.form.serach_plt_time[0]){
          this.form.start_time=this.form.serach_plt_time[0];
        }
        if(this.form.serach_plt_time[1]){
          this.form.end_time=this.form.serach_plt_time[1];
        }
      }

      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await getDevOpsSpaceDealWorkOrderApi(params);
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 排序事件
    async sortChange(column) {
      const { prop, order } = column;
      if(prop === 'create_time') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.create_time) - Date.parse(a.create_time) : Date.parse(a.create_time) - Date.parse(b.create_time);
        })
      }
    },
    // 弹出模板
    async showDialogVisible(type, row,  back = '') {
      if (type === 'releaseing') {
        return;
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = row;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true, ) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    changeReset(){
      this.form.title = '';
      this.form.models_code = '';
      this.form.submitter_id = '';
      this.form.serach_plt_time = '';
      this.options = [];
      this.form.dept_unicode = '';
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_dealtWorkOrder {

  .link_svg {
    position: absolute;
    left: -96px;
    top: 2px;
    transform: rotate(90deg);
    cursor: pointer;
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_dealtWorkOrder .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
</style>
